import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Card, Button, Stack } from "@mui/material";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { MARKETPLACE } from "@/data/mock-data";

export function MarketplaceDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const tpl = MARKETPLACE.find((t) => t.id === id);

  if (!tpl) return <Typography textAlign="center" py={6}>Template not found.</Typography>;

  return (
    <Box sx={{ maxWidth: 760, mx: "auto" }}>
      <Button startIcon={<ArrowBackIosNew sx={{ fontSize: 14 }} />} onClick={() => navigate("/marketplace")} sx={{ mb: 2 }}>
        Marketplace
      </Button>
      <Card sx={{ p: 3 }}>
        <Typography variant="h2" sx={{ mb: 1 }}>{tpl.name}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {tpl.description}
        </Typography>
        <Stack direction="row" spacing={3} sx={{ mb: 3 }}>
          <Stat label="Annual Return" value={`${tpl.ar}%`} color="primary.main" />
          <Stat label="Max Drawdown" value={`${tpl.maxDrawdown}%`} color="error.main" />
        </Stack>
        <Stack direction="row" spacing={1.5}>
          <Button variant="outlined">Test drive</Button>
          <Button variant="contained">Buy template</Button>
        </Stack>
      </Card>
    </Box>
  );
}

function Stat({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>{label}</Typography>
      <Typography variant="h4" sx={{ color, fontFeatureSettings: '"tnum" 1' }}>{value}</Typography>
    </Box>
  );
}
